import React from "react";
const QuickLinks = () => {
    return (React.createElement("nav", { id: "accessLinks", role: "navigation", "aria-label": "Liens d'\u00E9vitement" },
        React.createElement("p", { className: "sr-only" }, "Aller \u00E0 :"),
        React.createElement("menu", null,
            React.createElement("li", null,
                React.createElement("a", { href: "#main", title: "Acc\u00E9der au contenu", tabIndex: "1" }, "Contenu")),
            React.createElement("li", null,
                React.createElement("a", { href: "#mainNav", title: "Acc\u00E9der au menu principal", tabIndex: "2" }, "Menu principal")))));
};
export default QuickLinks;
